import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Engagement on student_engagements {
    id
    updated_at
    user_id
    user {
      user_id
      user_first_name
      user_last_name
      last_login_at
      user_pic
      student_profiles {
        graduation_year
      }
    }
    score
    timestamps
    properties
    notes
  }
`;

export const GET_ENGAGEMENT_DATA = gql`
  query getEngagements($expired: Boolean) {
    rows: v_students(
      where: {
        subscription_id: { _is_null: $expired }
        engagement: { score: { _gte: 0 } }
      }
      order_by: { engagement: { score: desc } }
    ) {
      graduation_year
      user_id
      user_first_name
      user_last_name
      last_login_at
      user_pic
      engagement {
        id
        notes
        properties
        timestamps
        score
      }
    }
    settings: settings_by_pk(key: "ENGAGEMENT_CONFIG") {
      key
      value
    }
  }
  ${FRAGMENT}
`;

export const GET_STUDENT_DATA = gql`
  query getEngagement($userId: Int!) {
    rows: student_engagements(where: { user_id: { _eq: $userId } }) {
      ...Engagement
      user {
        user_cognito_sub
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_ENGAGEMENT = gql`
  mutation updateEngagement($id: Int!, $data: student_engagements_set_input!) {
    update_student_engagements_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Engagement
    }
  }
  ${FRAGMENT}
`;
